module.exports = __webpack_public_path__ + "static/media/featured-img3.5fd8f7d8.jpg";